import reportOptimoveLogin from "@casino/client/optimove/reportLogin";
import useLogin from "@casino/legacy/client/components/Auth/Login/useLogin";
import startFraudEngine from "@casino/legacy/client/shared/fraud/fraudEngine";
import { setCookie } from "@workspace/cookies/browser";
import { track } from "@workspace/tracking";
import type FormValues from "../../Login/LoginBody/FormLogin/useFormLogin/FormValues";

type Args = {
  captchaRequired: boolean;
};

const useHandleLogin = ({ captchaRequired }: Args) => {
  const { handleLogin, loading } = useLogin({ captchaRequired });
  const doLogin = async (values: FormValues) => {
    const { data } = await handleLogin(values);
    const {
      token = "",
      deviceDataToken = "",
      errors,
      userManagement,
      sessionId,
    } = data?.userManagementLoginViaPassword ?? {};

    if (errors) {
      return { errors };
    }

    setCookie("token", token);
    startFraudEngine({ deviceDataToken });
    track("Login", { userId: userManagement?.currentProfile?._id });
    const optimoveUserId = userManagement?.currentProfile?._id;
    if (optimoveUserId) {
      reportOptimoveLogin(optimoveUserId);
    }

    return { userManagement, sessionId };
  };
  return { handleLogin: doLogin, loading };
};

export default useHandleLogin;
